module.exports = __webpack_public_path__ + "static/search1-4e5b181302e7e289e987e3b2e22463e6.png";